import { KeywordSearch } from "@/types/search";
import { PastBusinessFilter } from "@/types/pastbusiness";
import { ValueType } from "@/types/bid";
import { formatDate } from "date-fns";
import { subtractDays } from "@/libs/utils";

export const DefaultPastBusinessSearchKeywordList: KeywordSearch[] = [
  { title_or_doc: "TITLE", or_and: "OR", input_strings: [] },
];

export const sortList: ValueType[] = [
  {
    label: "날짜 내림차순",
    value: "upload_date|DESC",
  },
  {
    label: "날짜 오름차순",
    value: "upload_date|ASC",
  },
  {
    label: "금액 내림차순",
    value: "budget_amount|DESC",
  },
  {
    label: "금액 오름차순",
    value: "budget_amount|ASC",
  },
];

export const PastBusinessDateRangeList: ValueType[] = [
  { label: "하루 전", value: "1" },
  { label: "일주일 전", value: "7" },
  { label: "한 달 전", value: "30" },
  { label: "일 년 전", value: "365" },
  { label: "자유 입력", value: "" },
];

export const DefaultDateRange = "365";

export const DefaultPastBusinessFilter: PastBusinessFilter = {
  keywords: [],
  bool_op: "OR",
  category: "ALL",
  begin_dt: formatDate(
    subtractDays(new Date(), Number(DefaultDateRange)).toString(),
    "yyyy-MM-dd"
  ),
  end_dt: formatDate(new Date().toString(), "yyyy-MM-dd"),
  dmin_keyword: "",
  corp_keyword: "",
  min_amount: "0",
  max_amount: "0",
  sort_by: "upload_date",
  order: "DESC",
  page_no: 1,
  page_size: 100,
};

export const ContractMethodList: ValueType[] = [
  { label: "수의", value: "수의계약" },
  { label: "일반", value: "일반경쟁" },
  { label: "제한", value: "제한경쟁" },
  { label: "지명", value: "지명경쟁" },
  { label: "기타", value: "기타" },
];
